import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'fund-asset-class',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'fund-asset-class',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'fund-asset-class',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'fund-asset-class',
  action: ActionType.UPDATE,
};

export const FundAssetClass = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
